import React from 'react'
import PropTypes from 'prop-types'
import styled, { useTheme } from 'styled-components'
import { MaterialIcon } from '@dsny/dsny-component-library'
import { useTranslation } from 'react-i18next'

const Overlay = styled.span`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.5);
  pointer-events: none;
`

const ArchivedArtworkOverlay = ({ small = false }) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const size = small ? 16 : 24
  return (
    <Overlay role="img" aria-label={t('collections.archived')}>
      <MaterialIcon
        filled={false}
        name="Archive"
        color={theme.colors.neutralW100}
        aria-hidden="true"
        style={{ width: size, height: size }}
      />
    </Overlay>
  )
}

ArchivedArtworkOverlay.propTypes = { small: PropTypes.bool }

export default ArchivedArtworkOverlay
